<template>
  <v-select
    v-model="val"
    dir="rtl"
    :multiple="multiple"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :clearable="clearable"
    :placeholder="placeholder"
    :loading="loading"
    @option:selected="$emit('selected',$event)"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'DedicatedDietListFood',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'لیست غذاها',
    },
    placeholder: {
      type: String,
      default: 'انتخاب لیست',
    },
  },
  data() {
    return {
      Items: [],
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
  created() {
    this.get()
  },
  computed: {
    ...mapState('zirehState', { items: state => state.specialDietFoodListSelect }),
    ...mapState('zirehState', { flag: state => state.specialDietFoodListSelectFlag }),
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setSpecialDietFoodListSelectFlag', true)
        this.loading = true
        this.$http.post(
            this.$api.dedicatedfoodList.getall, {},
        )
            .then(res => {
              this.loading = false
                  this.$store.commit('zirehState/setSpecialDietFoodListSelect', res.data)
            })
      }
    },
  },
}
</script>
